<section>
  @if(showSimple){
    <div class="loading-spinner" *ngIf="displayDialog">
      <p-progressSpinner ariaLabel="loading" styleClass="w-3rem h-3rem" strokeWidth="6"/>
    </div>
  }@else {
    <p-dialog [(visible)]="displayDialog" [modal]="true" [autoZIndex]="true" [draggable]="false" [resizable]="false"
        [maximizable]="false" [closable]="false" [style]="{ width: '25rem' }">
  
        <ng-template pTemplate="header">
            <div class="text-center w-full">            
              {{translations.cargando}}
            </div>
        </ng-template>
  
        <ng-template pTemplate="content">
          <div class="w-full flex justify-content-center h-5rem">
            <p-progressSpinner ariaLabel="loading" styleClass="w-3rem h-3rem" strokeWidth="6"/>
          </div>
        </ng-template>
    </p-dialog>
  }
</section>
